import * as l from "react";
const e = (a) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.493 12.351a1 1 0 00-.037-1.072l-.612-.895a3 3 0 01-.2-3.05l.79-1.561a1 1 0 00-.204-1.178l-.918-.869a1 1 0 111.376-1.452l.917.87a3 3 0 01.613 3.533l-.79 1.56a1 1 0 00.066 1.017l.613.895a3 3 0 01.11 3.218l-.764 1.295a1 1 0 00-.005 1.006l.718 1.248a3 3 0 01-.307 3.433l-1.095 1.296a1 1 0 01-1.528-1.29l1.095-1.296a1 1 0 00.102-1.145l-.718-1.248a3 3 0 01.015-3.02l.763-1.295zm7.014 0a1 1 0 01.037-1.072l.612-.895a3 3 0 00.2-3.05l-.79-1.561a1 1 0 01.204-1.178l.918-.869a1 1 0 00-1.376-1.452l-.917.87a3 3 0 00-.613 3.533l.79 1.56a1 1 0 01-.066 1.017l-.613.895a3 3 0 00-.11 3.218l.764 1.295a1 1 0 01.005 1.006l-.719 1.248a3 3 0 00.308 3.433l1.095 1.296a1 1 0 001.528-1.29l-1.095-1.296a1 1 0 01-.102-1.145l.718-1.248a3 3 0 00-.015-3.02l-.763-1.295zm6.037-1.072a1 1 0 00-.037 1.072l.763 1.296a3 3 0 01.015 3.02l-.718 1.247a1 1 0 00.102 1.145l1.095 1.296a1 1 0 01-1.528 1.29L17.14 20.35a3 3 0 01-.308-3.433l.719-1.248a1 1 0 00-.005-1.006l-.763-1.296a3 3 0 01.11-3.217l.612-.895a1 1 0 00.067-1.016l-.791-1.561a3 3 0 01.613-3.534l.917-.869a1 1 0 011.376 1.452l-.918.87a1 1 0 00-.204 1.177l.79 1.56a3 3 0 01-.2 3.051l-.612.895z",
      fill: "#2d6ded"
    }
  )
), t = e;
export {
  t as default
};
